// extracted by mini-css-extract-plugin
module.exports = {"updateBtn":"styles_updateBtn__fQ8ww","container":"styles_container__ZD3qW","stars":"styles_stars__2MSBk"};